/*
 * @Author: fengxiaojing
 * @LastEditTime: 2023-06-27 11:23:28
 * @Description:
 * @LastEditors: Please set LastEditors
 */
import qs from 'qs'
import To from 'await-to-js'
import Callback from '@/services/Callback'
import { wizStandardInstance } from '@/services/instance'

export default class LocalSense {
  // 获取电子围栏
  static async getAllList(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(`/api/Local_Sense/electronic_fence?fencetype=${payload}`)
    )
    return Callback(err, res)
  }
  // 根据ID查找电子围栏信息
  static async getFenceDetail(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(`/api/Local_Sense/electronic_fence_by_id?${qs.stringify(payload)}`)
    )
    return Callback(err, res)
  }
  // 查询已登录账户权限内目标
  static async getRelationTags() {
    const [err, res] = await To(wizStandardInstance.get('/api/Local_Sense/authorized_target'))
    return Callback(err, res)
  }
  // 新增电子围栏
  static async addFence(payload) {
    const [err, res] = await To(
      wizStandardInstance.post('/api/Local_Sense/electronic_fence', payload)
    )
    return Callback(err, res)
  }
  // 编辑电子围栏
  static async editFence(payload) {
    const [err, res] = await To(
      wizStandardInstance.put('/api/Local_Sense/electronic_fence', payload)
    )
    return Callback(err, res)
  }
  // 获取电子围栏图层信息
  static async getFenceAreaInfo(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(`/api/Local_Sense/area_by_type?${qs.stringify(payload)}`)
    )
    return Callback(err, res)
  }
  // 删除电子围栏
  static async deleteFence(payload) {
    const [err, res] = await To(
      wizStandardInstance.delete(`/api/Local_Sense/electronic_fence?${qs.stringify(payload)}`)
    )
    return Callback(err, res)
  }
  // 获取未处理的告警信息列表
  static async getUntreatedWarningList(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(`/api/Local_Sense/new_alarm?${qs.stringify(payload)}`)
    )
    return Callback(err, res)
  }
  // 获取已处理的告警信息列表
  static async getTreatedWarningList(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(`/api/Local_Sense/handled_alarm?${qs.stringify(payload)}`)
    )
    return Callback(err, res)
  }
  // 获取告警类别列表
  static async getWarningTypeList() {
    const [err, res] = await To(wizStandardInstance.get('/api/Local_Sense/alarm_type'))
    return Callback(err, res)
  }
  // 处理告警
  static async handleWarning(payload) {
    const [err, res] = await To(wizStandardInstance.post('/api/Local_Sense/handle_alarm', payload))
    return Callback(err, res)
  }
  // 获取人员定位历史轨迹
  static async getPersonnelHistoryPath(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(
        `/api/Local_Sense/person_history_positon?from=${payload.from}&to=${payload.to}&isSearchVideo=${payload.isSearchVideo}&tagIdMsg=${payload.tagIdMsg}`
      )
    )
    return Callback(err, res)
  }
  // 获取人员定位信息列表
  static async getPersonnelPositionList(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(`/api/Local_Sense/person_position_by_tagid?tagid=${payload}`)
    )
    return Callback(err, res)
  }
  // 根据tagid获取人员信息详情
  static async getPersonnelPositionInfo(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(
        `/api/Local_Sense/person_information_by_tagid?${qs.stringify(payload)}`
      )
    )
    return Callback(err, res)
  }
  // 获取周界报警列表
  static async getAlarm(payload) {
    const [err, res] = await To(wizStandardInstance.post('/api/hikvision/eventlogs', payload))
    return Callback(err, res)
  }
  // 批量获取当前设备的测点编码集合
  static async getSSCSListDatas(payload) {
    const [err, res] = await To(
      wizStandardInstance.post('/api/siseuipment/sis/equipment/list', payload)
    )
    return Callback(err, res)
  }
  // 获取电子围栏模板列表
  static async getAllTemplateList(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(`/api/basedata/fence_template/?${qs.stringify(payload)}`)
    )
    return Callback(err, res)
  }
  // 通过id查询电子围栏模板详情
  static async getFenceTemplateDetail(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(`/api/basedata/fence_template/${payload.ID}`)
    )
    return Callback(err, res)
  }
  // 新增电子围栏模板
  static async addFenceTemplate(payload) {
    const [err, res] = await To(
      wizStandardInstance.post('/api/basedata/fence_template/insert', payload)
    )
    return Callback(err, res)
  }
  // 编辑电子围栏模板
  static async editFenceTemplate(payload) {
    const [err, res] = await To(
      wizStandardInstance.patch('/api/basedata/fence_template/update', payload)
    )
    return Callback(err, res)
  }
  // 删除电子围栏模板
  static async deleteFenceTemplate(payload) {
    const [err, res] = await To(
      wizStandardInstance.delete('/api/basedata/fence_template', {
        data: payload,
      })
    )
    return Callback(err, res)
  }
}
